<template>
  <div id="productDetails">
    <div  class="d-flex" style="background-color:rgba(26, 29, 32, 1);width: 100%;height: 50px;position: relative;border-bottom: 1px solid rgba(128, 128, 128, 0.3)">
      <div @click="goToGlobe" style="width: 380px;left: 15px;position: absolute;cursor: pointer;" class="d-flex">
        <v-img src="../../assets/top_bar/logoAndTitleNew.png" style="width:220px;flex:none;margin-left:1px;"></v-img>
      </div>
    </div>
    <div class="d-flex contents">
      <!--左侧面板-->
      <div ref="title" class="leftPanel"  v-if="showLeftPanel && detailInfo !== ''" style="display: flex;flex-direction: column;">
        <div class="leftPanel-title">{{detailInfo.imageCollection.title}}</div>
        <div style="position: relative;">
          <div class="leftPanel-subTitle">城市发展</div>
<!--          <div style="position:absolute;right: 0;top: 20px">-->
<!--            <div style="color: white;font-size: 14px;float: right">X{{detailInfo.imageCollection.price}}</div>-->
<!--            <span class="iconfontFamily" style="font-size: 20px;color: rgba(42, 130, 228, 1);float: right;margin-top: -5px">&#xe643;</span>-->
<!--          </div>-->
        </div>
        <div class="leftPanel-introduce">{{detailInfo.imageCollection.context}}</div>
        <div style="margin-top: 35px;background: black;flex-grow:1">
          <!--轮播图-->
          <div id="list" :class="{list:!hover,listHover:hover}" style="margin-left: 20px;margin-right: 20px" @mouseover="hover = true" @mouseout="hover = false">
            <div v-for="(item,index) in detailInfo.zMaterials" :key="index" :id="'item' + index" style="height: 80px;cursor: pointer;">
              <div @click="clickLayer(index)" style="margin-right: 5px" :style="{ 'width':index === currentIndex ?'80px':'50px','height':index === currentIndex ?'80px':'50px','background-color':'white','border':index === currentIndex ? '1px solid rgba(25, 118, 210, 1)' : 'none','margin-top':index === currentIndex ?'0px':'15px'}"><img :src="item.jpgThumb" :style="{ 'width':index === currentIndex ?'78px':'50px','height':index === currentIndex ?'78px':'50px',}"></div>
            </div>
          </div>
          <!--信息面板-->
          <div class="details">
            <!--拍摄地点-->
            <div class="d-flex details-item">
              <div class="details-property" >
                <div >拍摄地点：</div>
              </div>
              <div class="details-info">
                <div>{{detailInfo.zMaterials[currentIndex].posit}}</div>
              </div>
            </div>
            <!--拍摄时间-->
            <div class="d-flex details-item">
              <div class="details-property">
                <div >拍摄时间：</div>
              </div>
              <div class="details-info">
                <div>{{detailInfo.zMaterials[currentIndex].shootTimeStr}}</div>
              </div>
            </div>
            <!--拍摄设备-->
            <div class="d-flex details-item">
              <div class="details-property">
                <div>拍摄设备：</div>
              </div>
              <div class="details-info">
                <div>{{detailInfo.zMaterials[currentIndex].satellite}}</div>
              </div>
            </div>
            <!--影像素材-->
            <div class="d-flex details-item">
              <div class="details-property">
                <div>影像素材：</div>
              </div>
              <div class="details-info">
                <div v-show="detailInfo.zMaterials[currentIndex].type === 1">JPG</div>
                <div v-show="detailInfo.zMaterials[currentIndex].type === 2">3D</div>
                <div v-show="detailInfo.zMaterials[currentIndex].type === 3">卷帘</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--右侧面板-->
      <div v-if="detailInfo !== ''" :style="{'width':showLeftPanel ? 'calc(100% - 380px)':'100%'}" style="position: relative;">
        <div class="mainLayerArea">
          <image-detail v-if="updateLayer" ref="imageDetail"></image-detail>
        </div>
        <!--上一张-->
        <div v-show="detailInfo.zMaterials.length > 1 && currentIndex !== 0" @click="changeLayer('last')" class="changePage" style="left: 10px">
          <span class="iconfontFamily changePage-icon" > &#xe633;</span>
        </div>
        <!--下一张-->
        <div v-show="detailInfo.zMaterials.length > 1 && currentIndex !== detailInfo.zMaterials.length - 1" @click="changeLayer('next')" class="changePage" style="right: 10px">
          <span class="iconfontFamily changePage-icon"> &#xe634;</span>
        </div>

        <!--工具条-->
        <div id="toolBar">
          <v-tooltip open-delay="1000" top max-width="300" color="rgba(0, 0, 0, 0.4)">
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <div @click="download" v-bind="attrs" v-on="on" class="toolBarItem" style="margin-left: 25px" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}">
                  <p style="line-height:35px;font-size:20px;" class="iconfontFamily" :style="{color: detailInfo.imageCollection.status === 5 ? 'rgba(166, 166, 166, 1)': 'white'}">&#xe67e;</p>
                  <div :style="{color: detailInfo.imageCollection.status === 5 ? 'rgba(166, 166, 166, 1)': 'white'}" style="color: white;font-size: 16px;line-height: 32px;font-weight: 400;margin-left: 10px">下载</div>
                </div>
              </v-hover>
            </template>
            <span>{{detailInfo.imageCollection.status === 5 ? '素材已停用' : '素材下载'}}</span>
          </v-tooltip>

          <div style="height: 18px;width: 1px;background-color:rgba(166, 166, 166, 1);margin-top: 12px;margin-left: 15px"></div>

          <v-tooltip open-delay="1000" top max-width="300" color="rgba(0, 0, 0, 0.4)">
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <div>
                  <div v-if="detailInfo.imageCollection.status === 5" v-bind="attrs" v-on="on" class="toolBarItem" style="margin-left: 18px" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}">
                    <p class="iconfontFamily toolBarItemIcon" style="color: rgba(166, 166, 166, 1)">&#xe639;</p>
                  </div>

                  <div v-if="detailInfo.imageCollection.status !== 5" @click="like" v-bind="attrs" v-on="on" class="toolBarItem" style="margin-left: 18px" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}">
                    <p class="iconfontFamily toolBarItemIcon">{{likeStatus === 0 ? '&#xe639;':'&#xe648;'}}</p>
                  </div>
                </div>
              </v-hover>
            </template>
            <span>收藏</span>
          </v-tooltip>

          <v-tooltip open-delay="1000" top max-width="300" color="rgba(0, 0, 0, 0.4)">
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <div @click="share" v-bind="attrs" v-on="on" class="toolBarItem" style="margin-left: 18px" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}">
                  <p class="iconfontFamily toolBarItemIcon">&#xe67f;</p>
                </div>
              </v-hover>
            </template>
            <span>转发</span>
          </v-tooltip>

          <v-tooltip open-delay="1000" top max-width="300" color="rgba(0, 0, 0, 0.4)">
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <div @click="changeCompareMode" v-bind="attrs" v-on="on" class="toolBarItem" style="margin-left: 18px" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}">
                  <p class="iconfontFamily toolBarItemIcon" :style="{color: detailInfo.zMaterials[currentIndex].type === 3 ? 'white':'rgba(166, 166, 166, 1)'}">&#xe64e;</p>
                </div>
              </v-hover>
            </template>
            <span>对比旋转</span>
          </v-tooltip>

          <v-tooltip open-delay="1000" top max-width="300" color="rgba(0, 0, 0, 0.4)">
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <div @click="show3D" v-bind="attrs" v-on="on" class="toolBarItem" style="margin-left: 18px" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}">
                  <p class="toolBarItemIcon"  :style="{color: detailInfo.zMaterials[currentIndex].type === 2 ? 'white':'rgba(166, 166, 166, 1)'}">3D</p>
                </div>
              </v-hover>
            </template>
            <span>3D开关</span>
          </v-tooltip>

          <v-tooltip open-delay="1000" top max-width="300" color="rgba(0, 0, 0, 0.4)">
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <div @click="zoomIn" v-bind="attrs" v-on="on" class="toolBarItem" style="margin-left: 18px" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}">
                  <p class="iconfontFamily toolBarItemIcon">&#xe642;</p>
                </div>
              </v-hover>
            </template>
            <span>放大</span>
          </v-tooltip>

          <v-tooltip open-delay="1000" top max-width="300" color="rgba(0, 0, 0, 0.4)">
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <div @click="zoomOut" v-bind="attrs" v-on="on" class="toolBarItem" style="margin-left: 18px" :style="{'background': hover? 'rgba(99, 99, 99, 0.3)':''}">
                  <p class="iconfontFamily toolBarItemIcon">&#xe63b;</p>
                </div>
              </v-hover>
            </template>
            <span>缩小</span>
          </v-tooltip>
        </div>
      </div>

      <!--全屏按钮-->
      <div @click="leftPanelCtl" style="position: fixed;right: 20px;top:70px;width: 40px;height: 40px;background-color: #383838;border-radius: 50%;cursor: pointer">
        <p :style="{'color':isFullScreen ? '#04BEFE' : '#ffffff'}" style="line-height:40px;font-size:16px;cursor:pointer;text-align: center" class="iconfontFamily">&#xe604;</p>
      </div>

    </div>
    <download-products v-if="this.mainId !== '' && $store.state.showDownloadProductsDialog" :main-id="this.mainId"></download-products>

  </div>
</template>

<script>
import DownloadProducts from "@/components/download_products/DownloadProducts";
import ImageDetail from "@/components/image_details/ImageDetail";
export default {
  name: "ProductDetails",
  components: {ImageDetail, DownloadProducts, },
  mounted() {
    this.token = window.localStorage.getItem('authorToken')
    if(this.$route.query.mainId !== undefined && this.$route.query.mainId !== ''){
      this.mainId = this.$route.query.mainId
    }
    if(this.$store.state.threeDIndex !== -1){
      this.currentIndex = this.$store.state.threeDIndex
    }
    this.getDetailsById()
  },
  data(){
    return {
      isFullScreen:false,
      mainId:'f9c824d20ad14248aec7082435975fa2',
      likeStatus:0,
      detailInfo:'',
      showLeftPanel:true,
      currentIndex:0,
      token:'',
      updateLayer:true,
      hover:false,
    }
  },
  methods:{
    goToGlobe(){
      if(this.token === ''){
        this.$router.push({
          name: 'login',query: {goBack:'true'}
        })
        return
      }
      this.$router.push({
        path: '/globe',
      })
    },
    download(){
      if(this.detailInfo.imageCollection.status === 5){
        return;
      }
      if(this.token === ''){
        this.$router.push({
          name: 'login',query: {goBack:'true'}
        })
        return
      }
      this.$store.commit('setShowDownloadProductsDialog',true)
    },
    share(){
      this.$utils.shareImageLib(this.mainId,this.detailInfo.imageCollection.title,()=>{
        //toast
        this.$store.state.snackbarType = 'success';
        this.$store.state.snackbarText = '分享链接复制成功'
        this.$store.state.snackbarShow = true;
      })
    },
    getDetailsById(){
      let _url = ''
      if(this.token === "" || this.token === undefined || this.token === null){
        _url = '/authorApi/z-image-collection/getByIdNoLogin'
      }else{
        _url = '/authorApi/z-image-collection/getById'
      }
      this.$axios({
        method:"get",
        url:_url,
        params:{
          'mainId':this.mainId
        }
      }).then((resultData)=>{
        if(resultData.data.status === 200){
          this.detailInfo = resultData.data.data
          // this.detailInfo.zMaterials.push(this.detailInfo.zMaterials[2])
          this.likeStatus = resultData.data.data.collectStatus
          this.$nextTick(()=>{
            this.$refs.imageDetail.updateImageLayers(this.detailInfo.zMaterials[this.currentIndex])
          })
        }
      })
    },
    clickLayer(index){
      if(index !== this.currentIndex){
        this.scrollToMiddle(index)
      }
    },
    changeLayer(action){
      if(action === 'last'){
        if(this.currentIndex > 0){
          this.currentIndex = this.currentIndex - 1
          if(this.showLeftPanel){
            this.scrollToMiddle(this.currentIndex)
          }else{
            this.$refs.imageDetail.updateImageLayers(this.detailInfo.zMaterials[this.currentIndex])
          }
        }
      }else{
        if(this.currentIndex < this.detailInfo.zMaterials.length - 1){
          this.currentIndex = this.currentIndex + 1
          if(this.showLeftPanel){
            this.scrollToMiddle(this.currentIndex)
          }else{
            this.$refs.imageDetail.updateImageLayers(this.detailInfo.zMaterials[this.currentIndex])
          }
        }
      }
      if(this.detailInfo.zMaterials[this.currentIndex].type === 2){
        this.$store.commit('setThreeDIndex',this.currentIndex)
      }else{
        this.$store.commit('setThreeDIndex',-1)
      }
    },
    scrollToMiddle(index){
      let parent = document.getElementById('list');
      let offsetX = (55*(index) + 40) - (380 - 22*2)/2
      parent.scrollTo(offsetX,0)
      this.currentIndex = index
      this.$refs.imageDetail.updateImageLayers(this.detailInfo.zMaterials[this.currentIndex])
      if(this.detailInfo.zMaterials[this.currentIndex].type === 2){
        this.$store.commit('setThreeDIndex',this.currentIndex)
      }else{
        this.$store.commit('setThreeDIndex',-1)
      }
    },
    leftPanelCtl(){
      this.showLeftPanel = !this.showLeftPanel
      this.isFullScreen = !this.isFullScreen
      //刷新imageLayer使其新居中
      if(this.detailInfo.zMaterials[this.currentIndex].type !== 300){
        this.updateLayer = false
        let _this = this
        this.$nextTick(()=>{
          this.updateLayer = true
          this.$nextTick(()=>{
            _this.$refs.imageDetail.updateImageLayers(this.detailInfo.zMaterials[this.currentIndex])
            if(localStorage.getItem("tempCompareMode") !== undefined && localStorage.getItem("tempCompareMode") !== null){
              _this.$refs.imageDetail.compareMode = localStorage.getItem("tempCompareMode");
            }else{
              _this.$refs.imageDetail.compareMode = 'horizontal'
            }
          })
        })
      }
    },
    changeCompareMode(){
      if(this.detailInfo.zMaterials[this.currentIndex].type !== 3){
        return
      }
      this.$refs.imageDetail.changeCompareMode()
    },
    show3D(){
      if(this.detailInfo.zMaterials[this.currentIndex].type !== 2){
        return
      }
      this.$router.push({
        path: '/3DLayer',
        query: {
          layer: this.detailInfo.zMaterials[this.currentIndex].cite,
          bounds: this.detailInfo.zMaterials[this.currentIndex].geo,
          currentIndex:this.currentIndex
        }// 要传递的参数
      })
    },
    zoomIn(){
      this.$refs.imageDetail.zoomIn()
    },
    zoomOut(){
      this.$refs.imageDetail.zoomOut()
    },
    like(){
      if(this.token === ''){
        this.$router.push({
          name: 'login',query: {goBack:'true'}
        })
        return
      }
      let type;
      if(this.likeStatus === 0){
        type = 1
      }else{
        type = 0
      }
      this.$utils.likeOrCancelLikeImageLib(this.mainId,type,()=>{
        if(this.likeStatus === 0){
          this.likeStatus = 1

          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = "收藏成功"
          this.$store.state.snackbarType = 'success'

        }else{
          this.likeStatus = 0
        }
      })
    }
  }
}
</script>

<style lang="scss">

#productDetails{
  width: 100%;
  height:100%;
  background-color: black;
  #logo{
    width: 100%;
    height: 39px;
    color: white;
    font-size: 20px;
    line-height: 40px;
    padding-left: 10px;
    background-color: rgba(26, 29, 32, 1);
  }
  .contents{
    width: 100%;
    height: calc(100% - 50px)
  }
}

.leftPanel{
  width: 380px;
  min-width: 380px;
  height: 100%;
  background-color: rgba(27, 27, 27, 1);
  position: relative;
  padding-left: 22px;
  padding-right: 22px;
  border-right: 1px solid rgba(128, 128, 128, 0.3);
  &-title{
    color:white;
    font-size: 24px;
    margin-top: 20px;
    text-align: center;
  }
  &-subTitle{
    color:rgba(33, 144, 255, 1);
    font-size: 16px;
    margin-top: 20px;
    text-align: center;
  }
  &-introduce{
    color:white;
    font-size: 16px;
    margin-top: 20px;
    text-align: center;
  }
  .divider{
    background-color: rgba(229, 229, 229, 0.3);
    margin-top: 35px;
  }
}

//收起按键
.semiCircleButton{
  position: absolute;
  z-index: 100;
  cursor: pointer;
  &-rect{
    width: 17px;
    height: 34px;
    background-color: white;
    position: absolute;
    right: -16px;
    top: 20px;
    z-index: 100;
    border-top: 1px solid rgba(128, 128, 128, 0.3);
    border-bottom:  1px solid rgba(128, 128, 128, 0.3);
  }
  &-circle{
    width: 34px;
    height: 34px;
    border-radius: 17px;
    border-top:  1px solid rgba(128, 128, 128, 0.3);
    border-right:  1px solid rgba(128, 128, 128, 0.3);
    border-bottom:  1px solid rgba(128, 128, 128, 0.3);
    position: absolute;
    right: -34px;
    top: 20px;
    z-index: 100;
  }
  &-icon{
    width: 12px;
    height: 16px;
    color: rgba(56, 56, 56, 1);
    position: absolute;
    right: -19px;
    top: 25px;
    z-index: 100;
  }
}

.list{
  margin-top: 20px;
  width: 296px;
  height: 100px;
  overflow: hidden;
  overflow-x:scroll;
  display: flex;
  // 滚动条长轴
  &::-webkit-scrollbar {
       width: 6px;
       height: 6px;
       background-color: transparent;
       display: none;
     }
  // 滚动条的轨道的两端按钮，允许通过点击微调小方块的位置。
  &::-webkit-scrollbar-button {
       display: none;
     }
  // 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
  &::-webkit-scrollbar-thumb {
       background: rgba(25, 118, 210, 1);
       cursor: pointer;
       border-radius: 4px;
       display: none;
     }
  // 边角，即两个滚动条的交汇处
  &::-webkit-scrollbar-corner {
       display: none;
     }
  // 两个滚动条的交汇处上用于通过拖动调整元素大小的小控件
  &::-webkit-resizer {
       display: none;
     }
}

.listHover{
  margin-top: 20px;
  width: 296px;
  height: 100px;
  overflow: hidden;
  overflow-x:scroll;
  display: flex;
  // 滚动条长轴
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
  }
  // 滚动条的轨道的两端按钮，允许通过点击微调小方块的位置。
  &::-webkit-scrollbar-button {
    display: none;
  }
  // 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
  &::-webkit-scrollbar-thumb {
    background: rgba(25, 118, 210, 1);
    cursor: pointer;
    border-radius: 4px;
  }
  // 边角，即两个滚动条的交汇处
  &::-webkit-scrollbar-corner {
    display: none;
  }
  // 两个滚动条的交汇处上用于通过拖动调整元素大小的小控件
  &::-webkit-resizer {
    display: none;
  }
}

.functions{
  margin:35px auto 0 auto;
  width: max-content;
  #like{
    cursor: pointer;
    height: 50px;
    width: 50px;
    background-color: rgba(30, 64, 175, 1);
    border-radius: 3px;
  }
  #download{
    cursor: pointer;
    height: 50px;
    width: 180px;
    background-color: rgba(30, 64, 175, 1);
    border-radius: 3px;
    margin-left: 30px;
    font-size: 20px;
    color: white;
    line-height: 51px;
    text-align: center
  }
  #deactivated{
    cursor: pointer;
    height: 50px;
    width: 250px;
    background-color: rgba(56, 56, 56, 1);
    border-radius: 3px;
    margin-left: 20px;
    font-size: 20px;
    color: white;
    line-height: 50px;
    text-align: center
  }
}

.details{
  margin: 28px 45px 0 45px;
  &-item{
    width: max-content;
    margin-top: 12px;
  }

  &-property{
    width: 84px;
    div{
      color: rgba(166, 166, 166, 1);
      font-size: 16px;
      float: right;
    }
  }

  &-info{
    width: 165px;
    div{
      color: white;
      font-size: 16px;
      float: left;
    }
  }
}

.layer_button{
  width: 80px;
  height: 40px;
  border-radius: 5px;
  background: linear-gradient(90deg, rgba(41, 50, 60, 1) 0%, rgba(72, 85, 99, 1) 100%);
  border: 1px solid rgba(0, 0, 0, 1);
  position: absolute;
  left: 200px;
  top: 11px;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  color: white;
  cursor: pointer;
}

.changePage{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  background: #424242;
  width: 34px;
  height: 34px;
  text-align: center;
  &-icon{
    font-size: 18px;
    color: white;
    line-height: 34px;
    cursor: pointer
  }
}

.mainLayerArea{
  width: 100%;
  height: calc(100vh - 50px);
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

#toolBar{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 30px;
  width: 440px;
  height: 42px;
  background-color: rgb(0.25, 0, 0, 0);
  border-radius:21px;
  backdrop-filter: blur(20px);
  display: flex
}

.toolBarItem{
  display: flex;
  cursor: pointer;
  border-radius: 6px;
  height: 32px;
  margin-top: 5px;
  width: fit-content;
  padding: 0 5px
}

.toolBarItemIcon{
  line-height:32px;
  font-size:20px;
  color: white
}

</style>